import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  Output,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
	selector: 'app-chart',
	templateUrl: './chart.component.html',
	styleUrls: ['./chart.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	host: {
		class: 'p-element',
	},
})
export class UIChartComponent implements AfterViewInit, OnDestroy {
	@Input() type: any;

	@Input() plugins: any[] = [];

	@Input() width: string | undefined;

	@Input() height: string | undefined;

	@Input() responsive: boolean = true;

	@Input() get data(): any {
		return this._data;
	}
	set data(val: any) {
		this._data = val;
		this.reinit();
	}

	@Input() get options(): any {
		return this._options;
	}
	set options(val: any) {
		this._options = val;
		this.reinit();
	}

	@Output() onDataSelect: EventEmitter<any> = new EventEmitter();

	isBrowser: boolean = false;

	initialized: boolean;

	_data: any;

	_options: any = {};

	chart: any;

	constructor(
		@Inject(PLATFORM_ID) private platformId: any,
		public el: ElementRef
	) {}

	ngAfterViewInit() {
		this.initChart();
		this.initialized = true;
	}

	onCanvasClick(event) {
		if (this.chart) {
			const element = this.chart.getElementsAtEventForMode(
				event,
				'nearest',
				{ intersect: true },
				false
			);
			const dataset = this.chart.getElementsAtEventForMode(
				event,
				'dataset',
				{ intersect: true },
				false
			);

			if (element && element[0] && dataset) {
				this.onDataSelect.emit({
					originalEvent: event,
					element: element[0],
					dataset: dataset,
				});
			}
		}
	}

	initChart() {
		if (isPlatformBrowser(this.platformId)) {
			let opts = this.options || {};
			opts.responsive = this.responsive;

			// allows chart to resize in responsive mode
			if (opts.responsive && (this.height || this.width)) {
				opts.maintainAspectRatio = false;
			}

			this.chart = new Chart(this.el.nativeElement.children[0].children[0], {
				type: this.type,
				data: this.data,
				options: this.options,
				plugins: this.plugins,
			});
		}
	}

	getCanvas() {
		return this.el.nativeElement.children[0].children[0];
	}

	getBase64Image() {
		return this.chart.toBase64Image();
	}

	generateLegend() {
		if (this.chart) {
			return this.chart.generateLegend();
		}
	}

	refresh() {
		if (this.chart) {
			this.chart.update();
		}
	}

	reinit() {
		if (this.chart) {
			this.chart.destroy();
			this.initChart();
		}
	}

	ngOnDestroy() {
		if (this.chart) {
			this.chart.destroy();
			this.initialized = false;
			this.chart = null;
		}
	}
}
